export default {
  success: 'E00000',
  existFunctionName: 'E01611', // 功能名称已经存在
  invalidUser: 'E01607', // 用户名或者密码错误
  doubleName: 'E00021', // 图片重名
  noAccess: 'E07004', // 无权限，此时 400 错误
  disabled: 'E01608', // 账户未启用
  unmatchedToken: 'E07003', // token 不匹配(重复登录)
  invalidToken: 'E07002', // token 失效(超时不操作)
  existSon: 'E01614', // 功能下有子功能
  existChildMenu: 'E01615', // 存在字菜单
  existFeature: 'E01616', // 存在功能权限
  existMenu: 'E01602', // 菜单名称已存在
  existJobName: 'E03003', // 定时任务名称重复
  jobRunning: 'E03002', // job 运行中
  errorCron: 'E03013', // cron 表达式错误
  duplicatedTipName: 'E09006', // 名称重复
  duplicatedQuestion: 'E13017', // 题目名称·重复
  noAccount: 'E01617', // 帐号注销
  freezeAccount: 'E01618', // 帐号注销
  invalidID: 'E01621', // id 不一致
  invalidIP: 'E01622', // ip
  invalidPerson: 'E01623', // 非同一网点
  existOrgn: 'E06040', // 机构下已存在双录参数
};
